import React from 'react'
import { TextField, FormGroup, Button, SnackbarContent, withStyles } from '@material-ui/core'

const styles = {
}

const Plan = props => {
  const { onSubmit, loading, message, onNameChange, onMPChange, onPRChange, onReasonChange, onDateChange, onPP0Change, onVP0Change, onPP1Change, onVP1Change } = props

  return (
    <React.Fragment>
      {
        message &&
        <SnackbarContent
          message={message}
        />
      }
      <FormGroup>
        <TextField
          id="name"
          label="Name"
          margin="normal"
          onChange={onNameChange}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          id="minPenalty"
          label="minPenalty"
          type="number"
          margin="normal"
          onChange={onMPChange}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          id="penaltyRate"
          label="penaltyRate"
          type="number"
          margin="normal"
          onChange={onPRChange}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          id="reason"
          label="Reason"
          margin="normal"
          onChange={onReasonChange}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          id="date"
          label="StartAt"
          type="date"
          // defaultValue={`${new Date().getFullYear()}-${(new Date().getMonth() + 1).toString().padStart(2, '0')}-${(new Date().getDate()).toString().padStart(2, '0')}`}
          onChange={onDateChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </FormGroup>
      <TextField
        id="periodPrice[0]"
        label="periodPrice"
        type="number"
        margin="normal"
        min="0"
        onChange={onPP0Change}
      />
      <TextField
        id="validPeriods[0]"
        label="validPeriods"
        type="number"
        margin="normal"
        min="0"
        max="24"
        onChange={onVP0Change}
      />
      <TextField
        id="periodPrice[1]"
        label="periodPrice"
        type="number"
        margin="normal"
        min="0"
        onChange={onPP1Change}
      />
      <TextField
        id="validPeriods[1]"
        label="validPeriods"
        type="number"
        margin="normal"
        min="0"
        max="24"
        onChange={onVP1Change}
      />
      <FormGroup>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={loading}
          color="primary">
          Submit
            </Button>
      </FormGroup>
    </React.Fragment>
  )
}

export default withStyles(styles)(Plan)


// WEBPACK FOOTER //
// ./src/components/Plan/Add.jsx